module.exports = __webpack_public_path__ + "img/frontIdCard.e063a6be.svg";